<template>
  <v-card outlined>
    <ValidationObserver ref="form">
      <v-container>
        <v-toolbar flat dense>
          <div>{{$t("deliveryMethod.totalWeight")}}</div>
        </v-toolbar>
        <ValidationProvider rules="min_value:0" name="min_total_weight" v-slot="{ errors }">
          <v-text-field
            :label="$t('deliveryMethod.min')"
            v-model="totalWeights.min"
            type="number"
            suffix="KG"
            clearable
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
          :rules="totalWeights.min > 0 ? 'min_value:'+totalWeights.min : 'min_value:0'"
          name="max_total_weight"
          v-slot="{ errors }"
        >
          <v-text-field
            :label="$t('deliveryMethod.max')"
            v-model="totalWeights.max"
            type="number"
            suffix="KG"
            clearable
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
      </v-container>
    </ValidationObserver>
  </v-card>
</template>

<script>
  import { ValidationProvider, extend, ValidationObserver } from "vee-validate"
  import { min_value } from 'vee-validate/dist/rules'

  extend('min_value', {
    ...min_value,
    params: ['min']
  });

  export default {
    name: "totalWeightEligibility",
    components: {
    "ValidationProvider": ValidationProvider,
    "ValidationObserver": ValidationObserver,
    },
    props: {
      totalWeights: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.width <= 600
      },
    },
    methods: {
      validateForm() {
        return this.$refs.form.validate()
      }
    }
  }
</script>

